import * as React from "react";
import Tooltip from '@mui/material/Tooltip';
import Table from "@mui/material/Table";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import {
    createEmployeesDetails
} from "../Apihelper/ApiEmployeesDetails";

import Typography from "@mui/material/Typography";
import Header from '../Includes/Header';
import { useTheme as useAppTheme } from '../../contexts/ThemeContext';
import { styled } from "@mui/material/styles";

import { useState } from "react";
import { useEffect, useRef } from "react";
import { Card, Button, Grid, TextField, FormControl, InputLabel, Select, MenuItem, FormHelperText, Paper, Avatar } from "@mui/material";
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { MobileDatePicker, MobileTimePicker } from '@mui/x-date-pickers';
import { DesktopDatePicker, DesktopTimePicker } from '@mui/x-date-pickers';
import { StaticDatePicker } from '@mui/x-date-pickers/StaticDatePicker';
import { DemoContainer, DemoItem } from "@mui/x-date-pickers/internals/demo";
import { DatePicker, TimePicker } from '@mui/x-date-pickers';
import Menu from '@mui/material/Menu';
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import WbSunnyIcon from '@mui/icons-material/WbSunny';
import NightsStayIcon from '@mui/icons-material/NightsStay';
import Autocomplete from "@mui/material/Autocomplete";
import useMediaQuery from "@mui/material/useMediaQuery";

import CircularProgress from "@mui/material/CircularProgress";
import json2mq from "json2mq";

import { useNavigate } from "react-router-dom";
import AppToast from '../../components/Toast/AppToast';
import { generateCardNumber } from '../../utils/generateCardNumber';
import DeviceEnrollDialog from '../../components/DeviceEnroll/DeviceEnrollDialog';

const useStyles = styled((theme) => ({
  tableContainer: {
    maxWidth: 600,
    margin: "0 auto",
  },
  table: {
    display: "none", // Hide the table on all screens
    [theme.breakpoints.down("sm")]: {
      display: "table", // Show the table on small screens only (mobile view)
    },
  },
  cardContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      display: "none", // Hide the card container on small screens (mobile view)
    },
  },
  card: {
    width: "100%",
    margin: "8px",
    padding: "16px",
    borderRadius: "8px",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
    [theme.breakpoints.down("sm")]: {
      maxWidth: "300px", // Adjust the card width as needed
    },
  },
}));
const drawerWidth = 292;

// Add theme constants
const buildThemeColors = (appColors) => ({
  primary:      appColors.leaf,
  primaryLight: appColors.leaf,
  background:   '#F6F5F0',
  surface:      '#FFFFFF',
  text:         '#1B2420',
  textSecondary:'#5B6660',
  border:       '#E6E4DC',
});

function AddEmployees(props) {
  const { colors: appColors } = useAppTheme();
  const themeColors = buildThemeColors(appColors);
  const navigate = useNavigate();
  const [enrollTarget, setEnrollTarget] = useState(null); // { id, name } of the employee just added
  const { window1 } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const dateRef = useRef();

  const mediaQueryVar = useMediaQuery(
    json2mq({
      minWidth: 600,
    })
  );

  const container =
    window1 !== undefined ? () => window().document.body : undefined;

  const drawer = (
    <div className="d-flex flex-column h-100">
      <Header />
    </div>
  );

  const [selectedFile, setSelectedFiles] = useState([]);
  const [imagePreview, setImagePreview] = useState(null);
  const fileInputRef = React.useRef(null);
  const [openToast, setOpenToast] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');
  const ITEM_HEIGHT = 48;
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const [UseradminData, setUseradminData] = useState({
    selectedFile: null,
    address:'',
    fullname:'',
    email:'',
    phone:'',
    bloodgroup:'',
    designation:'',
    salary:'',
    batchnumber:'',
    joiningdate:null,
    morningStart: null,
    morningEnd: null,
    eveningStart: null,
    eveningEnd: null,
    excuseTime: '',
  });
  const [errors, setErrors] = useState({
    fullname: '',
    phone: '',
    email: '',
    address: '',
    designation: '',
    salary: '',
    bloodgroup: '',
    joiningdate:null,
    batchnumber: '',
    morningStart: null,
    morningEnd: null,
    eveningStart: null,
    eveningEnd: null,
    excuseTime: '',
  });
  const handleSnackbarOpen = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setOpenToast(true);
  };
  const handleToastClose = () => {
    setOpenToast(false);
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setUseradminData({ ...UseradminData, selectedFile: file });
    setImagePreview(URL.createObjectURL(file));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUseradminData({
      ...UseradminData,
      [name]: name === "email" ? value.toLowerCase() : name === "designation" ? value : value.toUpperCase(),
    });
  };

  const handleTimeChange = (slot, time) => {
      setUseradminData({
          ...UseradminData,
          [slot]: time
      });
  };

  const validate = () => {
    const newErrors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!UseradminData.fullname) newErrors.fullname = "Full name is required";
    if (!UseradminData.address) newErrors.address = "address is required";
    if (!UseradminData.salary) newErrors.salary = "salary is required";
    if (!UseradminData.bloodgroup) newErrors.bloodgroup = "blood group is required";
    if (!UseradminData.designation) newErrors.designation = "designation is required";
    if (!UseradminData.phone) {
      newErrors.phone = "Phone number is required";
    } else if (!/^\d{10}$/.test(UseradminData.phone)) {
      newErrors.phone = "Phone number must be 10 digits";
    }
    if (!UseradminData.email) {
      newErrors.email = "Email is required";
    } else if (!emailRegex.test(UseradminData.email)) {
      newErrors.email = "Invalid email format";
    }
    if (!UseradminData.excuseTime) newErrors.excuseTime = "Excuse time is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const handleSubmit = async () => {
    if (!validate()) {
      handleSnackbarOpen("Please fix the errors in the form", "error");
      return;
    }

    const userData = localStorage.getItem("userdata");
    const userDataObj = JSON.parse(userData);
    const userToken = userDataObj.token;

    if (!UseradminData.batchnumber) {
      UseradminData.batchnumber = generateCardNumber();
      setUseradminData((prev) => ({ ...prev, batchnumber: UseradminData.batchnumber }));
    }

    let morningStartDate = UseradminData.morningStart ? new Date(UseradminData.morningStart) : null;
    let morningEndDate = UseradminData.morningEnd ? new Date(UseradminData.morningEnd) : null;
    let eveningStartDate = UseradminData.eveningStart ? new Date(UseradminData.eveningStart) : null;
    let eveningEndDate = UseradminData.eveningEnd ? new Date(UseradminData.eveningEnd) : null;

    let morningSlot = morningStartDate
        ? `${morningStartDate.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit', hour12: true })} - ${
            morningEndDate && morningEndDate.toLocaleTimeString ? morningEndDate.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit', hour12: true }) : ''
          }`
        : null;

    let eveningSlot = eveningStartDate
        ? `${eveningStartDate.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit', hour12: true })} - ${
            eveningEndDate && eveningEndDate.toLocaleTimeString ? eveningEndDate.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit', hour12: true }) : ''
          }`
        : null;

    try {
      const res = await createEmployeesDetails(userToken, {
          ...UseradminData,
          morningSlot: morningSlot,
          eveningSlot: eveningSlot,
      });
      if (res.code == "200") {
        handleSnackbarOpen(res.message, 'success');
        setImagePreview(null);
        setUseradminData({
          selectedFile:null,
          address:'',
          fullname:'',
          email:'',
          phone:'',
          bloodgroup:'',
          designation:'',
          salary:'',
          batchnumber:"",
          joiningdate:null,
          morningStart: null,
          morningEnd: null,
          eveningStart: null,
          eveningEnd: null,
          excuseTime: '',
        });
        if (res.data && res.data.id) {
          setEnrollTarget({ id: res.data.id, name: res.data.name });
        } else {
          navigate('/employeesdetail');
        }
      } else {
        handleSnackbarOpen(res.message, 'error');
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    const storedData = localStorage.getItem("userdata");
    if (!storedData) {
      navigate('/');
    }
    setUseradminData((prev) => ({ ...prev, batchnumber: generateCardNumber() }));
  }, []);

  return (
    <Box sx={{ display: 'flex', height: '100vh', backgroundColor: themeColors.background }}>
      <CssBaseline />
      <Box>
        <Header />
      </Box>
      <Box 
        component="main" 
        sx={{ 
          flexGrow: 1, 
          overflowY: 'auto', 
          padding: '24px',
          backgroundColor: themeColors.background
        }}
      >
        <div style={{ display: 'flex', flexDirection: 'column', gap: '24px', marginTop: '64px' }}>
          {/* Header Section */}
          <Box sx={{ 
            display: 'flex', 
            justifyContent: 'space-between',
            alignItems: 'center',
            backgroundColor: themeColors.surface,
            padding: '20px',
            borderRadius: '12px',
            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)'
          }}>
            <Typography 
              variant="h5" 
              sx={{ 
                color: themeColors.primary,
                fontWeight: 600,
                fontSize: { xs: '1.25rem', sm: '1.5rem' }
              }}
            >
              Add New Employee
            </Typography>
                <Button
              variant="outlined" 
              onClick={() => navigate('/employeesdetail')}
                  startIcon={<ArrowBackIcon />}
                  sx={{
                color: themeColors.primary,
                borderColor: themeColors.primary,
                '&:hover': {
                  borderColor: themeColors.primaryLight,
                  backgroundColor: 'rgba(37, 99, 235, 0.04)'
                }
              }}
            >
              Back to List
                </Button>
          </Box>

          {/* Form Section */}
          <Paper sx={{ 
            p: 3,
            borderRadius: '12px',
            backgroundColor: themeColors.surface,
            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)'
          }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
              {/* Profile Photo Section */}
              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1.5 }}>
                <Typography variant="subtitle1" sx={{ color: themeColors.primary, fontWeight: 600, alignSelf: 'flex-start' }}>
                  Profile Photo
                </Typography>
                <input
                  ref={fileInputRef}
                  type="file"
                  accept="image/*"
                  style={{ display: 'none' }}
                  onChange={handleImageChange}
                />
                <Box
                  onClick={() => fileInputRef.current.click()}
                  sx={{
                    position: 'relative',
                    cursor: 'pointer',
                    borderRadius: '50%',
                    display: 'inline-flex',
                    '&:hover .camera-overlay': { opacity: 1 },
                  }}
                >
                  <Avatar
                    src={imagePreview}
                    sx={{
                      width: 110,
                      height: 110,
                      bgcolor: '#e2e8f0',
                      border: `3px solid ${appColors.evergreen}`,
                      fontSize: '2.5rem',
                      color: appColors.evergreen,
                    }}
                  >
                    {!imagePreview && (UseradminData.fullname?.[0]?.toUpperCase() || '?')}
                  </Avatar>
                  <Box
                    className="camera-overlay"
                    sx={{
                      position: 'absolute',
                      inset: 0,
                      borderRadius: '50%',
                      bgcolor: 'rgba(31,122,84,0.55)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      opacity: 0,
                      transition: 'opacity 0.2s ease',
                    }}
                  >
                    <CameraAltIcon sx={{ color: '#fff', fontSize: 28 }} />
                  </Box>
                </Box>
                <Typography variant="caption" sx={{ color: themeColors.textSecondary }}>
                  Click to upload photo (JPG, PNG)
                </Typography>
              </Box>

              {/* Personal Information Section */}
              <Box>
                <Typography variant="subtitle1" sx={{ 
                  color: themeColors.primary,
                  fontWeight: 600,
                  mb: 2 
                }}>
                  Personal Information
                </Typography>
                <Box sx={{ 
                  display: 'flex', 
                  flexDirection: { xs: 'column', sm: 'row' },
                  gap: 2
                }}>
                  <Box sx={{ flex: 1 }}>
                  <TextField
                      fullWidth
                      label="Full Name"
                    name="fullname"
                    value={UseradminData.fullname}
                    onChange={handleChange}
                    error={!!errors.fullname}
                    helperText={errors.fullname}
                      sx={{
                        '& .MuiOutlinedInput-root': {
                          borderRadius: '8px',
                          backgroundColor: themeColors.background,
                          '&:hover .MuiOutlinedInput-notchedOutline': {
                            borderColor: themeColors.primary
                          },
                          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                            borderColor: themeColors.primary
                          }
                        }
                      }}
                    />
                  </Box>
                  <Box sx={{ flex: 1 }}>
                    <TextField
                      fullWidth
                      label="Blood Group"
                      name="bloodgroup"
                      value={UseradminData.bloodgroup}
                      onChange={handleChange}
                      error={!!errors.bloodgroup}
                      helperText={errors.bloodgroup}
                      sx={{
                        '& .MuiOutlinedInput-root': {
                          borderRadius: '8px',
                          backgroundColor: themeColors.background,
                          '&:hover .MuiOutlinedInput-notchedOutline': {
                            borderColor: themeColors.primary
                          },
                          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                            borderColor: themeColors.primary
                          }
                        }
                      }}
                    />
                  </Box>
                </Box>
              </Box>

              {/* Contact Information Section */}
              <Box>
                <Typography variant="subtitle1" sx={{ 
                  color: themeColors.primary,
                  fontWeight: 600,
                  mb: 2 
                }}>
                  Contact Information
                </Typography>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                  <Box sx={{ 
                    display: 'flex', 
                    flexDirection: { xs: 'column', sm: 'row' },
                    gap: 2
                  }}>
                    <Box sx={{ flex: 1 }}>
                      <TextField
                        fullWidth
                        label="Email"
                        name="email"
                        type="email"
                        value={UseradminData.email}
                        onChange={handleChange}
                        error={!!errors.email}
                        helperText={errors.email}
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            borderRadius: '8px',
                            backgroundColor: themeColors.background,
                            '&:hover .MuiOutlinedInput-notchedOutline': {
                              borderColor: themeColors.primary
                            },
                            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                              borderColor: themeColors.primary
                            }
                          }
                        }}
                      />
                    </Box>
                    <Box sx={{ flex: 1 }}>
                  <TextField
                        fullWidth
                        label="Phone"
                    name="phone"
                        type="number"
                    value={UseradminData.phone}
                    onChange={handleChange}
                    error={!!errors.phone}
                    helperText={errors.phone}
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            borderRadius: '8px',
                            backgroundColor: themeColors.background,
                            '&:hover .MuiOutlinedInput-notchedOutline': {
                              borderColor: themeColors.primary
                            },
                            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                              borderColor: themeColors.primary
                            }
                          }
                        }}
                      />
                    </Box>
                  </Box>
                  <TextField
                    fullWidth
                    label="Address"
                    name="address"
                    value={UseradminData.address}
                    onChange={handleChange}
                    error={!!errors.address}
                    helperText={errors.address}
                    multiline
                    rows={2}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: '8px',
                        backgroundColor: themeColors.background,
                        '&:hover .MuiOutlinedInput-notchedOutline': {
                          borderColor: themeColors.primary
                        },
                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                          borderColor: themeColors.primary
                        }
                      }
                    }}
                  />
                </Box>
              </Box>

              {/* Employment Information Section */}
              <Box>
                <Typography variant="subtitle1" sx={{ 
                  color: themeColors.primary,
                  fontWeight: 600,
                  mb: 2 
                }}>
                  Employment Information
                </Typography>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                  <Box sx={{ 
                    display: 'flex', 
                    flexDirection: { xs: 'column', sm: 'row' },
                    gap: 2
                  }}>
                    <Box sx={{ flex: 1 }}>
                      <FormControl 
                        fullWidth
                        error={!!errors.designation}
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            borderRadius: '8px',
                            backgroundColor: themeColors.background,
                            '&:hover .MuiOutlinedInput-notchedOutline': {
                              borderColor: themeColors.primary
                            },
                            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                              borderColor: themeColors.primary
                            }
                          }
                        }}
                      >
                        <InputLabel>Designation</InputLabel>
                    <Select
                          name="designation"
                      value={UseradminData.designation}
                      label="Designation"
                      onChange={handleChange}
                    >
                      <MenuItem value="">Select Designation</MenuItem>
                      <MenuItem value="manager">Manager</MenuItem>
                      <MenuItem value="trainer">Trainer</MenuItem>
                          <MenuItem value="perfectclining">Perfect Cleaning</MenuItem>
                      <MenuItem value="supervisor">Supervisor</MenuItem>
                      <MenuItem value="pujarinana">Pujari Nana</MenuItem>
                    </Select>
                        {errors.designation && (
                          <FormHelperText>{errors.designation}</FormHelperText>
                        )}
                  </FormControl>
                    </Box>
                    <Box sx={{ flex: 1 }}>
                  <TextField
                        fullWidth
                        label="Salary/Month"
                    name="salary"
                    type="number"
                    value={UseradminData.salary}
                    onChange={handleChange}
                    error={!!errors.salary}
                    helperText={errors.salary}
                        InputProps={{
                          startAdornment: <Typography sx={{ color: themeColors.textSecondary, mr: 1 }}>₹</Typography>
                        }}
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            borderRadius: '8px',
                            backgroundColor: themeColors.background,
                            '&:hover .MuiOutlinedInput-notchedOutline': {
                              borderColor: themeColors.primary
                            },
                            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                              borderColor: themeColors.primary
                            }
                          }
                        }}
                      />
                    </Box>
                  </Box>
                  <Box sx={{ 
                    display: 'flex', 
                    flexDirection: { xs: 'column', sm: 'row' },
                    gap: 2
                  }}>
                    <Box sx={{ flex: 1 }}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          label="Joining Date"
                      value={UseradminData.joiningdate}
                      onChange={(date) => setUseradminData({ ...UseradminData, joiningdate: date })}
                      format="DD/MM/YYYY"
                          slotProps={{
                            textField: {
                              fullWidth: true,
                              error: !!errors.joiningdate,
                              helperText: errors.joiningdate,
                              sx: {
                                '& .MuiOutlinedInput-root': {
                                  borderRadius: '8px',
                                  backgroundColor: themeColors.background,
                                  '&:hover .MuiOutlinedInput-notchedOutline': {
                                    borderColor: themeColors.primary
                                  },
                                  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                    borderColor: themeColors.primary
                                  }
                                }
                              }
                            }
                          }}
                        />
                  </LocalizationProvider>
                    </Box>
                    <Box sx={{ flex: 1 }}>
                  <TextField
                        fullWidth
                        label="Card Number"
                        placeholder="Enter Card Number..."
                    name="batchnumber"
                        type="number"
                    value={UseradminData.batchnumber}
                    onChange={handleChange}
                    error={!!errors.batchnumber}
                    helperText={errors.batchnumber}
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            borderRadius: '8px',
                            backgroundColor: themeColors.background,
                            '&:hover .MuiOutlinedInput-notchedOutline': {
                              borderColor: themeColors.primary
                            },
                            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                              borderColor: themeColors.primary
                            }
                          }
                        }}
                      />
                    </Box>
                  </Box>
                </Box>
              </Box>

              {/* Time Slots Section */}
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <Box>
                  <Typography variant="subtitle1" sx={{ color: themeColors.primary, fontWeight: 600, mb: 2 }}>
                    Time Slots
                  </Typography>
                  <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 2 }}>
                    {/* Morning Slot Card */}
                    <Box sx={{ flex: 1, border: '1px solid #c8e6c9', borderRadius: '10px', overflow: 'hidden' }}>
                      <Box sx={{ bgcolor: '#e8f5e9', px: 2, py: 1, display: 'flex', alignItems: 'center', gap: 1, borderBottom: '1px solid #c8e6c9' }}>
                        <WbSunnyIcon sx={{ color: '#f59e0b', fontSize: 18 }} />
                        <Typography variant="subtitle2" sx={{ color: themeColors.primary, fontWeight: 600 }}>
                          Morning Slot
                        </Typography>
                      </Box>
                      <Box sx={{ p: 2, display: 'flex', alignItems: 'flex-start', gap: 1 }}>
                        <Box sx={{ flex: 1, minWidth: 0 }}>
                          <TimePicker
                            label="Start Time"
                            value={UseradminData.morningStart}
                            onChange={(time) => handleTimeChange('morningStart', time)}
                            maxTime={dayjs().hour(11).minute(59)}
                            slotProps={{
                              textField: {
                                fullWidth: true, size: 'small',
                                error: !!errors.morningStart,
                                helperText: errors.morningStart,
                                sx: { '& .MuiOutlinedInput-root': { borderRadius: '8px', backgroundColor: themeColors.background, '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: themeColors.primary }, '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: themeColors.primary } } }
                              }
                            }}
                          />
                        </Box>
                        <Typography sx={{ mt: 1, color: themeColors.textSecondary, fontWeight: 500, userSelect: 'none', flexShrink: 0 }}>→</Typography>
                        <Box sx={{ flex: 1, minWidth: 0 }}>
                          <TimePicker
                            label="End Time"
                            value={UseradminData.morningEnd}
                            onChange={(time) => handleTimeChange('morningEnd', time)}
                            minTime={UseradminData.morningStart?.isValid() ? UseradminData.morningStart.add(1, 'minute') : dayjs().hour(0).minute(1)}
                            maxTime={dayjs().hour(11).minute(59)}
                            slotProps={{
                              textField: {
                                fullWidth: true, size: 'small',
                                error: !!errors.morningEnd,
                                helperText: errors.morningEnd,
                                sx: { '& .MuiOutlinedInput-root': { borderRadius: '8px', backgroundColor: themeColors.background, '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: themeColors.primary }, '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: themeColors.primary } } }
                              }
                            }}
                          />
                        </Box>
                      </Box>
                    </Box>

                    {/* Evening Slot Card */}
                    <Box sx={{ flex: 1, border: '1px solid #c8e6c9', borderRadius: '10px', overflow: 'hidden' }}>
                      <Box sx={{ bgcolor: '#e8f5e9', px: 2, py: 1, display: 'flex', alignItems: 'center', gap: 1, borderBottom: '1px solid #c8e6c9' }}>
                        <NightsStayIcon sx={{ color: '#6366f1', fontSize: 18 }} />
                        <Typography variant="subtitle2" sx={{ color: themeColors.primary, fontWeight: 600 }}>
                          Evening Slot
                        </Typography>
                      </Box>
                      <Box sx={{ p: 2, display: 'flex', alignItems: 'flex-start', gap: 1 }}>
                        <Box sx={{ flex: 1, minWidth: 0 }}>
                          <TimePicker
                            label="Start Time"
                            value={UseradminData.eveningStart}
                            onChange={(time) => handleTimeChange('eveningStart', time)}
                            minTime={dayjs().hour(12).minute(0)}
                            slotProps={{
                              textField: {
                                fullWidth: true, size: 'small',
                                error: !!errors.eveningStart,
                                helperText: errors.eveningStart,
                                sx: { '& .MuiOutlinedInput-root': { borderRadius: '8px', backgroundColor: themeColors.background, '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: themeColors.primary }, '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: themeColors.primary } } }
                              }
                            }}
                          />
                        </Box>
                        <Typography sx={{ mt: 1, color: themeColors.textSecondary, fontWeight: 500, userSelect: 'none', flexShrink: 0 }}>→</Typography>
                        <Box sx={{ flex: 1, minWidth: 0 }}>
                          <TimePicker
                            label="End Time"
                            value={UseradminData.eveningEnd}
                            onChange={(time) => handleTimeChange('eveningEnd', time)}
                            minTime={UseradminData.eveningStart?.isValid() ? UseradminData.eveningStart.add(1, 'minute') : dayjs().hour(12).minute(1)}
                            slotProps={{
                              textField: {
                                fullWidth: true, size: 'small',
                                error: !!errors.eveningEnd,
                                helperText: errors.eveningEnd,
                                sx: { '& .MuiOutlinedInput-root': { borderRadius: '8px', backgroundColor: themeColors.background, '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: themeColors.primary }, '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: themeColors.primary } } }
                              }
                            }}
                          />
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </LocalizationProvider>

                <Box sx={{ mt: 3 }}>
                    <TextField
                    fullWidth
                    label="Excuse Time (minutes)"
                        name="excuseTime"
                    type="number"
                        value={UseradminData.excuseTime}
                        onChange={handleChange}
                        error={!!errors.excuseTime}
                        helperText={errors.excuseTime}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: '8px',
                        backgroundColor: themeColors.background,
                        '&:hover .MuiOutlinedInput-notchedOutline': {
                          borderColor: themeColors.primary
                        },
                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                          borderColor: themeColors.primary
                        }
                      }
                    }}
                  />
                </Box>

              {/* Submit Button */}
              <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Button
                  variant="contained"
                  onClick={handleSubmit}
                  sx={{
                    backgroundColor: themeColors.primary,
                    color: themeColors.surface,
                    px: 4,
                    py: 1,
                    borderRadius: '8px',
                    '&:hover': {
                      backgroundColor: themeColors.primaryLight
                    }
                  }}
                >
                  Add Employee
                </Button>
              </Box>
            </Box>
          </Paper>
        </div>
      </Box>

      <DeviceEnrollDialog
        open={!!enrollTarget}
        token={(() => { try { return JSON.parse(localStorage.getItem("userdata")).token; } catch (e) { return ""; } })()}
        personType="employee"
        autoStart
        personId={enrollTarget?.id}
        personName={enrollTarget?.name}
        onClose={() => { setEnrollTarget(null); navigate('/employeesdetail'); }}
      />
      <AppToast open={openToast} message={snackbarMessage} severity={snackbarSeverity} onClose={handleToastClose} />
    </Box>
  );
}

export default AddEmployees;